// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_30c682', '__Inter_Fallback_30c682'","fontStyle":"normal"},"className":"__className_30c682"};